'use client';
import { Div } from 'themes/jumbo/@jumbo/shared';
//import AddIcon from '@mui/icons-material/Add';
import { JumboDdMenu } from 'themes/jumbo/@jumbo/components';
//import RemoveIcon from '@mui/icons-material/Remove';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import LockIcon from '@mui/icons-material/Lock';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Public from "@mui/icons-material/Public";
import { useJumboDialog } from 'themes/jumbo/@jumbo/components/JumboDialog/hooks/useJumboDialog';
import { MenuItemProps } from 'themes/jumbo/@jumbo/types';
import useSwalWrapper from 'themes/jumbo/@jumbo/vendors/sweetalert2/hooks';
import FoldersActions from "actions/FoldersAction";
import EventsEmitter from "events/EventsEmitter";
import {
  Chip,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Card,
  Typography,
  Tooltip
} from '@mui/material';
import { ProjectProps } from 'themes/jumbo/app/_components/views/type';
import { getCachedData } from "api/Cache";
import { useHistory } from 'react-router-dom';
import {
	openEditDialog,
  remoteDeleteProject
} from 'store/projects';
import NotificationModel from 'components/notificationPanel/model/NotificationModel';
import { addNotification } from 'components/notificationPanel/store/dataSlice';
import { useDispatch } from 'react-redux';
import React, { useContext } from 'react';
import { tss } from "tss-react";
import {CatalogContext} from "views/Catalog";
import { getAssetPath } from 'themes/jumbo/app/_utilities/helpers';
import { getAccessLevel } from "actions/ViewerTools";
import { ReactComponent as DefaultImage } from './icon-earth.svg';
import { formatDate } from "services/UtilsService";

const useStyles = tss.create(() => ({
  ellipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box"
  },
  multiLineEllipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical"
  }
}));
const labelMenuItems = [
  { icon: <EditIcon />, title: 'Edit', action: 'edit' },
  { icon: <DeleteIcon />, title: 'Delete', action: 'delete' },
];

type ProjectType = ProjectProps & {
  ID: string;
  name: string;
  description: string;
  file_date: string;
  thumbnail?: string;
  image?: string;
  timezone?: string;
};

const ProjectItem = ({ item, handleCheckboxClick, selectedItems }: { item: ProjectType, handleCheckboxClick: (e: any) => void, selectedItems: any[] }) => {
  const [expanded, setExpanded] = React.useState(false);
  const { ID:projectID, name:projectName = 'Unknown Project', description:projectDescription = '', image = '', thumbnail = '', file_date:creationDate = '' } = item;
  const data: any = getCachedData();
  const projectAccessLevel = getAccessLevel(projectID);
  const hasProjectAccess = projectAccessLevel === 'full'
  var views = data["views"];
  const { showDialog, hideDialog } = useJumboDialog();
  const { classes } = useStyles();
  const { 
      hasActiveSubscription,
      defaultProjects
  } = useContext<any>(CatalogContext);


  const projectViews = Object.values(views).filter((view: any) => view.project === projectID);
  const viewsImages: any[] = projectViews.filter((view: any) => view.has_thumbnail === "1" && view.thumb);
  let projectImage;
  const isDefaultProject = defaultProjects.includes(projectID);

  if (viewsImages.length && !(image || thumbnail)) {
    projectImage = viewsImages[/*viewsImages.length * Math.random() | */0].thumb;
  }
  const history = useHistory();
	const dispatch: any = useDispatch();

  const handleClick = (e: any) => {
    const klass = e.target?.classList || '';

    if (e.target?.type === 'checkbox') return;
    if (klass.contains('MuiModal-backdrop')) return;
    
    history.push(`/catalog/${projectID}`);
  };

  

  const deleteSelectedProjects = async () => {
    const cachedData = getCachedData();
    const projectsDispatchs: any[] = [];
    const __item = FoldersActions.allEntities.find((entity: any) => entity.ID === projectID);
    if (isDefaultProject || !__item) return;

    const deletedProject = cachedData['projectsRef'].find(
        (projRef: any) => projRef['project_ref'] === projectID
    );
    deletedProject && projectsDispatchs.push(dispatch(remoteDeleteProject({ itemId: projectID, projectId: deletedProject['project'] })));
    
    if (projectsDispatchs.length) {
        try {
            const results = await Promise.allSettled(projectsDispatchs);
            const allFulfilled = results.every((result) => result.status === 'fulfilled' && result?.value?.type !== 'projects/delete/rejected');
            FoldersActions.reloadCatalog(() => {
                hideDialog();
                if (allFulfilled) {
                    dispatch(addNotification(NotificationModel({ message: 'project is deleted successfully.', options: { variant: 'success' } })));
                    //setTimeout(() => {
                      //window.location.reload();
                      EventsEmitter.emit("reloadData", "");
                    //}, 100);
                } else {
                    dispatch(addNotification(NotificationModel({ message: 'Error deleting project.', options: { variant: 'error' } })));
                }
            });
            
            EventsEmitter.emit("signalr_update", {
              type: "entity_update",
              action: "reload_all",
            });
        } catch (error) {
          dispatch(addNotification(NotificationModel({ message: 'Error deleting project.', options: { variant: 'error' } })));
        }
    }
}

  const Swal = useSwalWrapper();

  const sweetAlerts = () => {
    Swal.fire({
      title: 'Your account has limited access!',
      text: 'We have limited your access to some features. Please upgrade your current plan to access this feature.',
      /*imageUrl: getAssetPath(
        `assets/images/subscription.webp`,
        '450x200'
      ),*/
      imageWidth: 450,
      imageHeight: 200,
      imageAlt: 'Custom image',
      confirmButtonText: "Upgrade my plan",
    }).then((result) => {
      result.isConfirmed && history.push("/profile");
    });
  };
  const handleMoreAction = React.useCallback(
    (menuItem: MenuItemProps) => {

      if (isDefaultProject || !hasActiveSubscription) {
        !hasActiveSubscription && sweetAlerts();
        return;
      }
      switch (menuItem?.action) {
        case 'edit':
          dispatch(openEditDialog(item));
          
          break;
        case 'delete':
          showDialog({
            variant: 'confirm',
            title: 'Are you sure?',
            content: 'Once you delete a project that cannot be reversed.',
            onYes: () => deleteSelectedProjects(),
            onNo: () => hideDialog(),
          });
      }
    },
    [showDialog, Swal, hideDialog]
  );

  return (
    <Card sx={{ p: 0, borderRadius:0, boxShadow: 'none' }} id={`project-${projectID}`}>
      <Accordion
        expanded={expanded}
        onChange={handleClick}
        sx={{ borderRadius: 0 }}
      >
        <AccordionSummary
          //expandIcon={expanded ? <RemoveIcon /> : <AddIcon />}
          aria-controls='panel1bh-content'
          id='panel1bh-header'
          sx={{
            px: {xs: 0, sm: 0, lg: 3},
            flexDirection: 'row-reverse',

            '& .MuiAccordionSummary-content': {
              alignItems: 'center',

              '&.Mui-expanded': {
                margin: '12px 0',
              },
            },
            '.MuiAccordionSummary-expandIconWrapper': {
              borderRadius: 1,
              border: 1,
              color: 'text.secondary',
              borderColor: 'divider',
              transform: 'none',
              height: 28,
              width: 28,
              alignItems: 'center',
              justifyContent: 'center',
              mr: 1,

              '&.Mui-expanded': {
                transform: 'none',
                color: 'primary.main',
                borderColor: 'primary.main',
              },

              '& svg': {
                fontSize: '1.25rem',
              },
            },
          }}
        >
          {/*<Div sx={{ flexShrink: 0, px: 1 }}>
            <Checkbox sx={{ my: -0.5 }} onChange={handleCheckboxClick} checked={selectedItems.includes(projectID)} value={projectID} disabled={isDefaultProject || !hasProjectAccess} />
          </Div>*/}
          <Div sx={{ flexShrink: 0, px: 2 }}>
            <Avatar
              sx={{ width: {xs: 35, sm: 35, lg: 75}, height: {xs: 35, sm: 35, lg: 75}, bgcolor: 'rgba(32,32,32,.05)', borderRadius: '12px' }}
              alt={item.name}
              src={projectImage}
              variant='rounded'
            >
              {!projectImage ? <DefaultImage style={{ width: '100%', height: '100%' }} /> : ""}
            </Avatar>
          </Div>
          <Div
            sx={{
              //maxWidth: { xs: 'auto', lg: '55%' },
              width : { xs: 'auto', md: '40%', lg: '55%' },
              flexShrink: 0,
              px: 1,
              flex: { xs: '1', lg: '0 1 auto' },
              marginRight: 'auto'
            }}
          >
            <Typography variant={'h2'} mb={0.5} fontSize={17}>
              {projectName}
            </Typography>
            <Typography
              fontSize={'16px'}
              variant={'body1'}
              color={'text.secondary'}
              className={classes.ellipsis}
              sx={{
                display: { xs: 'none', sm: 'none', md: 'none', lg: 'none', xl: 'block' },
                fontSize: '14px !important',
              }}
            >
              {projectDescription }
            </Typography>
          </Div>
          <Div
            sx={{
              display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex', xl: 'flex', minWidth: '100px' },
              textAlign: 'center',
              flexShrink: 0,
              px: 1,
            }}
          >
            {!!creationDate && (
              <Typography 
                variant={'body1'} 
                color={'text.secondary'} 
                sx={{
                  fontSize: '14px !important', 
                  padding: '2px 9px', 
                  backgroundColor: (theme) => theme.palette.background.default,
                  color: (theme) => theme.palette.text.primary,
                  borderRadius: '4px', 
                  fontWeight:'400 !important',
                  whiteSpace: 'nowrap'
                }}
              >
                {formatDate(creationDate)}
              </Typography>
            )}
          </Div>
          <Div
            sx={{
              display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex', xl: 'flex', minWidth: '75px' },
              width: '10%',
              textAlign: 'center',
              flexShrink: 0,
              px: 1,
            }}
          >
            <Chip
                size={'small'}
                label={`${projectViews.length} view(s)`}
                sx={{
                  transform: 'scale(.9)',
                  textAlign: 'center',
                  display: {xs: 'none', sm:'none', md:'flex', lg:'flex', xl:'flex'},
                  bgcolor: 'rgba(60, 71, 95, .85)',
                  color: '#fff',
                  borderRadius: '8px',
                  pb: '2px'
                }}
              />
          </Div>
          <Div
            sx={{
            marginLeft: 'auto',
            }}
          >
            { hasProjectAccess && !isDefaultProject ? (
              <JumboDdMenu
                icon={<Tooltip title="More actions" placement="top" arrow><MoreHorizIcon /></Tooltip>}
                menuItems={labelMenuItems}
                onClickCallback={handleMoreAction}
              />
            ) : (
                <Tooltip title="Read Only Project" placement="top" arrow>
                  <LockIcon sx={{width: 20, height: 20, color: (theme) => theme.palette.text.primary, mr: '10px'}} />
                </Tooltip>
            )}
          </Div>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            borderTop: 1,
            borderColor: 'divider',
            p: (theme) => theme.spacing(2, 2, 2, 8.25),
          }}
        >
        </AccordionDetails>
      </Accordion>
    </Card>
  );
};
export default ProjectItem ;
